export default __webpack_public_path__ + "static/media/graphic_1.df56ec1d.svg";